import { render } from "./schools-state.vue?vue&type=template&id=271d1e6a"
import script from "./schools-state.js?vue&type=script&lang=js"
export * from "./schools-state.js?vue&type=script&lang=js"

import "./schools-state.vue?vue&type=style&index=0&id=271d1e6a&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__